import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { getRegionais } from "./services"

export const actionGetRegionais: any = createAsyncThunk(
  "GET_REGIONAIS",
  async (_, { getState }) => {
    const { getDivisoes: { divisaoSelected } }: any = getState()
    const { data } = await getRegionais(divisaoSelected)
    return data
  }
)

const regionaisSlices = createSlice({
  name: "GET_REGIONAIS",
  initialState: {
    regionalSelected: null,
    regionais: [],
    feedbackError: "",
    status: "",
  },
  reducers: {
    actionSelectRegional: (state, { payload }) => {
      state.regionalSelected = payload
    },
  },
  extraReducers: {
    [actionGetRegionais.pending]: (state) => {
      state.status = "loading"
    },
    [actionGetRegionais.fulfilled]: (state, action) => {
      state.status = "success"
      state.regionais = action.payload
    },
    [actionGetRegionais.rejected]: (state, payload) => {
      state.status = "failed"
      state.feedbackError = "Deu erro"
    },
  }
})

export default regionaisSlices.reducer
export const { actionSelectRegional } = regionaisSlices.actions